var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAwsAmplify16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/16/Arch_AWS-Amplify-Console_16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0816",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5252",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/16/Arch_AWS-Amplify-Console_16",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-BG/16/Mobile",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.103283,17.9360099 L11.711283,9.00400987 L12.710283,7.50000987 L17.848283,17.9360099 L16.103283,17.9360099 Z M13.223283,6.27800987 C13.144283,6.11800987 12.986283,6.01200987 12.807283,6 C12.633283,5.99900987 12.457283,6.07400987 12.358283,6.22300987 L10.719283,8.69100987 C10.622283,8.83900987 10.609283,9.02800987 10.688283,9.18800987 L15.343283,18.6570099 C15.427283,18.8280099 15.601283,18.9360099 15.791283,18.9360099 L18.652283,18.9360099 C18.825283,18.9360099 18.985283,18.8470099 19.077283,18.7000099 C19.167283,18.5540099 19.176283,18.3700099 19.100283,18.2150099 L13.223283,6.27800987 Z M6.38128297,17.9360099 L9.91628297,12.0230099 L10.569283,13.3890099 L9.01028297,15.9900099 C8.91728297,16.1440099 8.91628297,16.3360099 9.00428297,16.4930099 C9.09228297,16.6500099 9.25928297,16.7470099 9.43928297,16.7470099 L12.131283,16.7470099 L12.706283,17.9360099 L6.38128297,17.9360099 Z M12.896283,16.0290099 C12.813283,15.8560099 12.638283,15.7470099 12.446283,15.7470099 L10.322283,15.7470099 L11.565283,13.6720099 C11.652283,13.5280099 11.660283,13.3510099 11.587283,13.1990099 L10.416283,10.7510099 C10.335283,10.5850099 10.171283,10.4760099 9.98828297,10.4680099 C9.80528297,10.4520099 9.62928297,10.5520099 9.53628297,10.7110099 L5.07128297,18.1800099 C4.97828297,18.3340099 4.97628297,18.5260099 5.06528297,18.6830099 C5.15428297,18.8390099 5.32028297,18.9360099 5.49928297,18.9360099 L13.501283,18.9360099 C13.673283,18.9360099 13.833283,18.8480099 13.925283,18.7020099 C14.016283,18.5560099 14.027283,18.3740099 13.952283,18.2190099 L12.896283,16.0290099 Z",
    id: "AWS-Amplify-Console_Icon_16_Squid",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAwsAmplify16);
export default __webpack_public_path__ + "static/media/Arch_AWS-Amplify_16.a2642e2d8ddcaf440fb64db2b3da4cf0.svg";
export { ForwardRef as ReactComponent };